import React from 'react';
import { Span, Text } from 'styles';

export function StatusText({ name, val, unit }) {
  return (
    <Text $type="12" $color="white">
      {name}&nbsp;
      <Span $type="m14" $color="white">
        {val}
      </Span>
      {unit && (
        <Span $type="11" $color="white">
          {unit}
        </Span>
      )}
    </Text>
  );
}
